export default "__VITE_ASSET__D5y8Ok4J__"